<template>
    <dash
        icon="fa fa-comment"
        :titulo="titulo"
        @click.native="
            $router.push({
                name: 'Pesquisas_Responder',
                params: {
                    pesquisaId: tipo
                }
            })
        "
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        },

        titulo: {
            type: String
        },

        tipo: {
            type: Number
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
